import { DELIVERY_METHODOLOGY } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';

export const deliveryMethodologyListRequest = () => ({
  url: DELIVERY_METHODOLOGY,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.MASTER_MS,
});

export const createDeliveryMethodology = (methodology) => ({
  url: DELIVERY_METHODOLOGY,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload: {
    methodology,
    is_active: 1, // Matches Postman collection keys
  },
  service: serviceName.MASTER_MS,
});

export const updateDeliveryMethodology = (methodId, methodology, isActive) => ({
  url: `${DELIVERY_METHODOLOGY}/${methodId}`, // FIX: Appended ID to URL to prevent 404
  method: 'put',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload: {
    methodology,
    is_active: Number(isActive), // Matches Postman collection keys
  },
  service: serviceName.MASTER_MS,
});
